// This function allow to reference all chunks
__webpack_require__.cssAssetFileName = function(chunkId) {
	// return url for filenames based on template
	return "corn-catering-oo-web-" + chunkId + "." + "b7bfc3bb6dd90a7545ee" + ".css";
};